import React from "react";
import { Box, Container, TablePagination } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router";
import { ApiClient } from "../../api/client";
import { RateTableListResponse } from "../../api/rateTable";
import ListToolbar from "../../components/ListToolbar";
import { useAsync } from "../../components/Loading/useAsync";
import { useLoadableState } from "../../components/Loading/useLoadableState";
import RateTableListResults from "../../components/rateTables/RateTableListResults";

const RateTableList = () => {
  const navigate = useNavigate();
  const [rateTables, setRateTables] = useLoadableState<RateTableListResponse>({
    rate_tables: [],
    total_count: 0,
  });

  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(0);

  const getAllRateTables = React.useCallback(
    (client: ApiClient) => client.rate.table.getAll(page, limit),
    [page, limit]
  );

  const handleLimitChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | undefined
  ) => {
    const newPageLimit = parseInt(event?.target.value || "", 10);

    setLimit(isNaN(newPageLimit) ? 25 : newPageLimit);
    setPage(0);
  };

  const handlePageChange = (
    _: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  useAsync(getAllRateTables, setRateTables);

  return (
    <>
      <Helmet>
        <title>Rate Table List</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <ListToolbar
            title="Rate Tables"
            newButtonTitle="Add rate table"
            newUrl="/app/rateTables/new"
          />
          <Box sx={{ pt: 3 }}>
            <RateTableListResults
              rateTables={rateTables}
              onClick={(x) => navigate(`/app/rateTable/${x}`)}
            >
              <TablePagination
                component="div"
                count={Number(rateTables.data.total_count) || 0}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleLimitChange}
                page={page}
                rowsPerPage={limit}
                rowsPerPageOptions={[5, 10, 25]}
              />
            </RateTableListResults>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default RateTableList;
